import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import CreateEditViewAlert from "../../components/alert-management/create-edit-view-alert";
import { allUsersList } from "../../redux/actions/general-action";
import errorToast from "../../components/helper-components/error-toast";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../../components/helper-components/overlay-loading";

function AddAlert() {
  const dispatch = useDispatch();
  const [userList, setUserList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const seperateData = (data) => {
    const Groups = [];
    const Users = [];

    data.forEach((groupObj) => {
      const groupName = Object.keys(groupObj)[0];

      Groups.push({
        name: groupName,
        selected: false,
      });

      groupObj[groupName].forEach((user) => {
        Users.push({
          group: groupName,
          user_name: user.user_name,
          user_id: user.user_id,
          selected: false,
        });
      });
    });

    setGroups(Groups);
    setUsers(Users);
  };
  const onSuccess = (data) => {
    setUserList(data?.data);
    seperateData(data?.data);
    setLoading(false);
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };
  useEffect(() => {
    if (!loading) {
      setLoading(true);
      dispatch(allUsersList(onSuccess, onError));
    } else return;
  }, []);

  return (
    <InnerLayout backBtn={true} title="Create New Alert">
      <LoadingOverlay isLoading={loading} />
      <CreateEditViewAlert userList={userList} groups={groups} users={users} />
    </InnerLayout>
  );
}

export default AddAlert;
